export function initCheckboxClassToggler() {
  window.onclick = event => {
    const {checked, dataset} = event.target
    if (dataset && dataset.appendClass && dataset.appendClassTo) {
      const t = document.querySelector(dataset.appendClassTo)
      if (!t) {
        return
      }
      if (checked) {
        t.classList.add(dataset.appendClass)
      } else {
        t.classList.remove(dataset.appendClass)
      }
    }
  }
}

export function initButtonPressedToggler() {
  window.onclick = event => {
    const {dataset} = event.target
    if (
      dataset &&
      dataset.togglePressed &&
      dataset.appendClass &&
      dataset.appendClassTo
    ) {
      const pressed = event.target.getAttribute('aria-pressed') !== 'true'
      event.target.setAttribute('aria-pressed', `${pressed}`)

      const t = document.querySelector(dataset.appendClassTo)
      if (!t) {
        return
      }
      if (pressed) {
        t.classList.add(dataset.appendClass)
      } else {
        t.classList.remove(dataset.appendClass)
      }
      event.target.focus()
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/initUI.js